package com.kinoshazam

/**
 * Runtime API configuration — values come from [BuildKonfig] (generated per Gradle task / flavor).
 *
 * Flavors (no manual edits):
 * - **local** — `http://localhost:8080` (desktop), `10.0.2.2:8080` (Android emulator)
 * - **prod**  — `https://api.kinoshka.net/api/v1/`
 *
 * Use kinoshka Gradle tasks (`androidLocalDebug`, `desktopProdDmg`, …) or standard
 * debug/release tasks; flavor is inferred from the task name.
 *
 * Physical device on LAN: `api.host.override=192.168.x.x` in `local.properties`.
 */
object Constants {

    val IS_LOCAL_TEST: Boolean get() = BuildKonfig.IS_LOCAL

    val PROD_HOST: String get() = BuildKonfig.PROD_HOST

    val LOCAL_PORT: Int get() = BuildKonfig.LOCAL_PORT

    val URL_PATH: String get() = BuildKonfig.URL_PATH

    val LOCAL_HOST_OVERRIDE: String get() = BuildKonfig.LOCAL_HOST_OVERRIDE

    val APP_ID: String get() = BuildKonfig.APP_ID

    val APP_NAME: String get() = BuildKonfig.APP_NAME

    val ENABLE_NETWORK_LOGS: Boolean get() = BuildKonfig.ENABLE_NETWORK_LOGS

    /** @deprecated Use [PROD_HOST] / [resolveApiHost] */
    val BASE_URL: String get() = PROD_HOST

    /** @deprecated Use [resolveApiHost] — do not put port into host */
    val LOCAL_BASE_URL: String get() = "localhost:$LOCAL_PORT"
}

expect fun defaultLocalApiHost(): String

fun resolveApiHost(): String {
    if (!Constants.IS_LOCAL_TEST) return Constants.PROD_HOST
    return Constants.LOCAL_HOST_OVERRIDE.trim().ifEmpty { defaultLocalApiHost() }
}
